import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Icon,
  ClickablePopoverMenu,
  Modal,
  CheckboxGroup
} from 'components';
import { useSetState } from 'utils/hooks/useSetState';
import { useHistory, useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  UiAnnouncementCardRead,
  UiContentTitle,
  UiContent,
  UiCreateWeek,
  UiCreateDate,
  UiCreateDateBox,
  UiContentBox,
  UiCardHeader,
  UiCardContent,
  UiCreateDateAll,
  UiCardFooter,
  UiCardHeaderRow,
  UiCardFooterRow,
  UiCardFooterBox,
  UiCardFooterBoxTitle,
  UiCardFooterFileBox,
  UiCardFooterFileBoxLabel,
  UiCardType,
  UiCheckBlock
} from './AnnouncementCardRead.style';
import { format, getTime } from 'date-fns';
import { useUser } from 'store/user';

const useStyles = makeStyles({
	root: {
		color: '#fff',
	},

	download: {
		fontSize: '1.2rem',
		color: '#fff',
		cursor: 'pointer',
	}
});

export const AnnouncementCardRead = ({
  data = {},
  onDelete = () => { },
  onPin = () => { },
  cancelPin = () => { },
  onCheckListChange = () => { },
  isPinned = false
}) => {
  const {
    id: Announcementid, week, day, months, year, title, nickname, clock, groupName,
    checkList,
    content,
    fileName,
    fileUrl,
    publishedAt,
    isSchedule,
    isOwner,
    isStaff,
  } = data;

  const classes = useStyles();

  const [{ isModalOpen, editStatus,
    goods,
    goodsList,
    goodsLength,
    checkFlag,
    checkDelay,
  }, setState] = useSetState({
    isModalOpen: false,
    editStatus: null,
    goods: [],
    goodsList: [],
    goodsLength: 0,
    checkFlag: true,
    checkDelay: 3,
  });
  const [{ profile }] = useUser();
  const history = useHistory();
  const { organizationId, classId } = useParams();

  const setEditStatus = status => () => {
    if (status === EDIT_STATUS.EDIT) {
      history.push(!classId ? `/home/${organizationId}/announcement/${Announcementid}/${EDIT_STATUS.EDIT}`
      :organizationId ?
        `/home/${organizationId}/class/${classId}/announcement/${Announcementid}/${EDIT_STATUS.EDIT}` :
        `/home/class/${classId}/announcement/${Announcementid}/${EDIT_STATUS.EDIT}`
      );
    }
    setState({ editStatus: status, isModalOpen: status !== EDIT_STATUS.EDIT });

  };
  const EDIT_STATUS = {
    ALIGN_TOP: 'verticalAlignTop',
    DELETE: 'delete',
    EDIT: 'edit'
  };
  const popoverMenuList = [
    {
      label: isPinned ? '取消置頂' : '置頂',
      func: setEditStatus(EDIT_STATUS.ALIGN_TOP),
      iconName: 'verticalAlignTop',
      isShow: isOwner
    },
    { label: '刪除', func: setEditStatus(EDIT_STATUS.DELETE), iconName: 'delete', isShow: isOwner },

    { label: '編輯', func: setEditStatus(EDIT_STATUS.EDIT), iconName: 'edit', isShow: isOwner }
  ];
  const getModalStateHandler = state => {
    setState({ isModalOpen: state });
  };

  const deleteModalConfig = {
    text: '是否要將此項公告刪除？',
    confirmAction: () => onDelete(data)
  };

  const pinModalConfig = {
    text: '是否要將此項公告置頂？',
    confirmAction: () => onPin(data)
  };

  const cancelPinModalConfig = {
    text:'是否要將此項公告取消置頂？',
    confirmAction: () => cancelPin(data)
  };

  const ModalConfig =
    editStatus === EDIT_STATUS.DELETE ? deleteModalConfig : (isPinned ? cancelPinModalConfig : pinModalConfig);
  const buttons = [
    {
      text: '確認',
      func: ModalConfig.confirmAction
    },
    {
      text: '取消',
      color: 'highlight',
      func: () => { }
    }
  ];
  useEffect(() => {
    if (!checkList) return;
    const { id } = profile;//用戶ID
    let goodsLength = checkList.length;
    let checkedValue = [];
    let goodsList = [];
    checkList.forEach((item, index) => {
      let obj = {};
      obj['value'] = item.id;
      obj['label'] = item.dueAt ?
        <div>{item.description}
          <span className='active'> ~ {format(new Date(item.dueAt), 'yyyy-MM-dd')}</span>
        </div>
        : <div>{item.description}</div>;
      obj['disabled'] = (item.dueAt && (getTime(new Date(item.dueAt)) < getTime(new Date()))) ? true : false;
      goodsLength = (item.dueAt && (getTime(new Date(item.dueAt)) < getTime(new Date()))) ?
        goodsLength - 1 :
        goodsLength;
      item.checkUsers.length > 0 && item.checkUsers.forEach((val) => {
        if (val === id) {
          checkedValue.push(item.id);
        }
      });
      goodsList.push(obj);
    });
    setState({
      goodsList,
      goodsLength,
      goods: checkedValue
    });
  }, []);
  const changeHandler = async (val, itemVal, type) => {
    if (!checkFlag) return;
    setState({
      checkFlag: false
    });
    onCheckListChange(val, itemVal, type, Announcementid);
    setState({
      goods: val
    });
    let _cd = checkDelay;
    let clock = setInterval(() => {
      _cd -= 1;
      if (_cd <= 0) {
        clearInterval(clock);
        setState({
          checkFlag: true
        });
      }
    }, 1000);
  };
  const AnnouncementHeader = (
    <>
      <UiCardHeader>
        <UiCardHeaderRow>
          <UiCreateDateBox>
            <UiCreateWeek>{week}</UiCreateWeek>
            <UiCreateDateAll>
              <UiCreateDate>{months}-{day}</UiCreateDate>
              <UiCreateDate>{year}</UiCreateDate>
            </UiCreateDateAll>
          </UiCreateDateBox>
          <UiContentBox>
            <UiContentTitle>
              {title}
              {
                isPinned && (
                  <UiCardType type="pinned">置頂</UiCardType>
                )
              }
            </UiContentTitle>
            <UiContent>{nickname} {year}年 {months}月{day}日 {week} {clock}</UiContent>
            <UiContent>{groupName}</UiContent>
          </UiContentBox>
        </UiCardHeaderRow>
        <UiCardHeaderRow>
          {!publishedAt &&
            <UiCardType type='draft'>草稿</UiCardType>
          }
          {isSchedule &&
            <UiCardType>排程</UiCardType>
          }
          {isOwner &&
            <ClickablePopoverMenu menuList={popoverMenuList}>
              <Icon name="moreHoriz" className={classes.root} onClick={() => { }} />
            </ClickablePopoverMenu>
          }
        </UiCardHeaderRow>
      </UiCardHeader>
    </>
  );
  const AnnouncementFooter = (
    <>
      <UiCardFooter>
        <UiCardFooterRow>
          {goodsList.length > 0 &&
            <UiCardFooterBox>
              {(isStaff || !checkFlag) &&
                <UiCheckBlock></UiCheckBlock>
              }
              <UiCardFooterBoxTitle>提醒事項餘{goodsLength - goods.length}個</UiCardFooterBoxTitle>
              <CheckboxGroup type={'checkList'} data={goodsList} onChange={changeHandler} defaultValue={goods} />
            </UiCardFooterBox>
          }
          {fileName &&
            <UiCardFooterFileBox>
              <UiCardFooterFileBoxLabel>
                {fileName}
              </UiCardFooterFileBoxLabel>
              <UiCardFooterFileBoxLabel>
                <a href={fileUrl} download={fileName} target='_blank' rel="noopener noreferrer">
                  <Icon name={'getApp'} className={classes.download} />
                </a>
              </UiCardFooterFileBoxLabel>
            </UiCardFooterFileBox>
          }
        </UiCardFooterRow>
      </UiCardFooter>
    </>
  );
  return (
    <>
      {isOwner ?
        <>
          <Card header={AnnouncementHeader} backgroundColor={'#2b936d'} footer={AnnouncementFooter}>
            <UiAnnouncementCardRead>
              <UiCardContent>
                <UiContent dangerouslySetInnerHTML={{ __html: content }}></UiContent>
              </UiCardContent>
            </UiAnnouncementCardRead>
          </Card>
          <Modal
            isOpen={isModalOpen}
            text={ModalConfig.text}
            buttons={buttons}
            getModalState={getModalStateHandler}
          />
        </>
        :
        (publishedAt || !isSchedule) &&
        <>
          <Card header={AnnouncementHeader} backgroundColor={'#2b936d'} footer={AnnouncementFooter}>
            <UiAnnouncementCardRead>
              <UiCardContent>
                <UiContent dangerouslySetInnerHTML={{ __html: content }}></UiContent>
              </UiCardContent>
            </UiAnnouncementCardRead>

          </Card>
          <Modal
            isOpen={isModalOpen}
            text={ModalConfig.text}
            buttons={buttons}
            getModalState={getModalStateHandler}
          />
        </>

      }

    </>
  );
};

AnnouncementCardRead.propTypes = {
  data: PropTypes.shape({
    week: PropTypes.string,
    date: PropTypes.string,
    title: PropTypes.string,
    from: PropTypes.string,
    content: PropTypes.string
  }),
  isOwner: PropTypes.bool,
  onDelete: PropTypes.func,
  onPin: PropTypes.func,
  cancelPin: PropTypes.func,
  onCheckListChange: PropTypes.func,
  isPinned: PropTypes.bool
};


